<template>
  <v-dialog v-model="isDialog" persistent max-width="500">
    <v-card>
      <v-card-title>{{ $t('customer.select_date_time_to_get_data') }}</v-card-title>
      <v-card-text>
        <v-row class="mt-2">
          <v-col cols="6">
            <v-menu v-model="menuMeterDate" :close-on-content-click="false" transition="scale-transition" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="$helper.datelabel(formMeterDate.date)" :placeholder="$t('date')" outlined dense
                  hide-details readonly v-bind="attrs" v-on="on" :label="$t('date')" :disabled="isMainLoading"></v-text-field>
              </template>
              <v-date-picker v-model="formMeterDate.date" no-title locale="th" @input="menuMeterDate = false"
                :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3">
            <v-select v-model="formMeterDate.hour" :items="hourOptions" class="input-right" outlined dense hide-details
              :label="$t('time')" :disabled="isMainLoading" :no-data-text="$t('noinfo')"/>
          </v-col>
          <v-col cols="3">
            <v-select v-model="formMeterDate.minute" :items="minuteOptions" class="input-right" outlined dense
              hide-details :label="$t('timeunit.minute.long')" :disabled="isMainLoading" :no-data-text="$t('noinfo')"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn elevation="0" @click="$emit('input', false);" :disabled="isMainLoading">
          <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
        </v-btn>
        <v-btn @click="submit()" class="blue white--text" :loading="isMainLoading"
          :disabled="isMainLoading">
          <v-icon class="me-2">mdi-cloud-download</v-icon>{{ $t('meter.read_data_digital_meter') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    isMainLoading: Boolean,
    digitalMeterDataList: Array
  },
  data() {
    return {
      isDialog: false,
      menuMeterDate: false,
      formMeterDate: {
        date: this.$moment().format("YYYY-MM-DD"),
        hour: this.$moment().format("HH"),
        minute: "00"
      }
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.formMeterDate = {
          date: this.$moment().format("YYYY-MM-DD"),
          hour: this.$moment().format("HH"),
          minute: "00"
        }
        if (this.digitalMeterDataList?.find(d => d.partner == "xten") && !this.digitalMeterDataList?.find(d => d.partner != "xten")) {
          this.isDialog = true
        } else {
          this.$emit("input", false);
          this.$emit('onSuccess', this.$moment().toDate())
        }
      } else {
        this.isDialog = false
      }
    }
  },
  computed: {
    hourOptions() {
      let arr = []
      for (let i = 0; i <= 23; i++) {
        arr.push(this.$helper.formatNumberLength(i, 2))
      }
      return arr
    },
    minuteOptions() {
      let arr = []
      for (let i = 0; i <= 45; i += 15) {
        arr.push(this.$helper.formatNumberLength(i, 2))
      }
      return arr
    },
  },
  methods: {
    submit() {
      let dateTime = this.$moment(`${this.formMeterDate.date} ${this.formMeterDate.hour}:${this.formMeterDate.minute}`,"YYYY-MM-DD HH:mm").toDate()
      this.$emit('onSuccess', dateTime)
    }
  }
};
</script>

<style lang="scss" scoped></style>
